import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { cn } from "@/lib/utils";

export const ProductPicker = ({ products, value, onChange, testid = "product-picker", wrap = false }) => {
  const [open, setOpen] = useState(false);
  const selected = products.find((p) => p.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className={cn("flex w-full min-w-0 items-center justify-between gap-2 rounded-md border border-input bg-background px-3 text-left text-sm hover:border-primary/60 transition-colors", wrap ? "min-h-9 py-1.5" : "h-9")}
        >
          <span className={cn(wrap ? "product-name" : "min-w-0 flex-1 truncate", !selected && "text-muted-foreground")}>
            {selected ? `${selected.sku} · ${selected.name}` : "Select product…"}
          </span>
          <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] min-w-[320px] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search SKU or product…" data-testid={`${testid}-search`} />
          <CommandList className="max-h-72">
            <CommandEmpty>No product found.</CommandEmpty>
            <CommandGroup>
              {products.map((p) => (
                <CommandItem
                  key={p.id}
                  value={`${p.sku} ${p.name} ${p.category}`}
                  onSelect={() => { onChange(p.id); setOpen(false); }}
                  data-testid={`${testid}-option-${p.sku}`}
                >
                  <Check className={cn("mr-2 h-4 w-4", value === p.id ? "opacity-100 text-primary" : "opacity-0")} />
                  <span className="font-mono text-[11px] text-muted-foreground mr-2 shrink-0">{p.sku}</span>
                  <span className={wrap ? "product-name" : "truncate"}>{p.name}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
